import { type RefObject, useState } from 'react';

import DebouncedA11yAnnouncer from '../../A11yAnnouncer/DebouncedA11yAnnouncer';
import { type UncontrolledNumericStepperHandle, NumericStepper } from '../../atoms/NumericStepper';
import styles from './BuyableRecipe.module.scss';

interface BuyableRecipePortionCounterProps {
    defaultPortions: number;
    setPortions: (quantity: number) => void;
    minValue: number;
    maxValue: number;
    stepperRef?: RefObject<UncontrolledNumericStepperHandle | null>;
    incrementBy?: number;
}

const BuyableRecipePortionCounter = (props: BuyableRecipePortionCounterProps) => {
    const [portions, setPortions] = useState(props.defaultPortions);
    const a11yAnnounceText = `Produkterna är nu anpassade för ${portions} portioner`;

    return (
        <div className={styles.PortionCounter}>
            <DebouncedA11yAnnouncer
                announcerName="BuyableRecipePortionCounterAnnouncer"
                text={a11yAnnounceText}
            />
            <span className={styles.PortionCounterHeader}>Portioner</span>
            <NumericStepper
                ref={props.stepperRef}
                theme="secondary"
                defaultValue={portions}
                onConfirm={(quantity) => {
                    setPortions(quantity);
                    props.setPortions(quantity);
                }}
                minValue={props.minValue}
                maxValue={props.maxValue}
                incrementBy={props.incrementBy || 2}
                inputLabel="Antal portioner"
                addButtonLabel="Öka antal portioner"
                removeButtonLabel="Minska antal portioner"
            />
        </div>
    );
};

export default BuyableRecipePortionCounter;
